// Campus photo for /colleges/cuny-bernard-m-baruch-college: CC BY 4.0, by Kidfly182, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABaruch_College_October_2025.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/cuny-bernard-m-baruch-college/; credited under the photo.
const photo = {
    "slug": "cuny-bernard-m-baruch-college",
    "alt": "Looking up at Baruch College's glass Newman Vertical Campus tower against a cloudy sky",
    "src": "/colleges/cuny-bernard-m-baruch-college/campus-1600.webp",
    "srcSmall": "/colleges/cuny-bernard-m-baruch-college/campus-800.webp",
    "srcMid": "/colleges/cuny-bernard-m-baruch-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/cuny-bernard-m-baruch-college/og.jpg",
    "title": "Baruch College October 2025",
    "author": "Kidfly182",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABaruch_College_October_2025.jpg",
    "read": "2026-10-01"
};

export default photo;
